export default __webpack_public_path__ + "static/media/carmax.928898e9.jpg";